<template>
  <div :class="{'pc-bg' : isMobile == 'pc'}">
    <div class="sector-info" v-if="isMobile == 'pc'">
      <div class="navigation-title" style="margin-left: 1rem;margin-top: 0;padding-top: 1rem"><span @click="()=>{$router.push('/foundationProject')}">{{ $t('FoundationProject') }}</span> <i class="el-icon-arrow-right"></i> {{ fundProjectInfo.name }}</div>
      <div style="" class="sector-info-top">
        <el-row v-if="screenWidth>640" :gutter="20" style="display: flex;align-items: center;justify-content: center;">
          <el-col :span="10">
            <img style="width: 100%;border-radius: 1rem;object-fit:cover;" :src="fundProjectInfo.imgUrl" alt="">
          </el-col>
          <el-col :span="14">
            <div style="display: flex;align-items: center;justify-content: center;width:100%;">
              <div>
                <h2>{{fundProjectInfo.name}}</h2>
                <div style="font-size: 1.2rem;margin-top: 2rem;line-height: 2;">{{fundProjectInfo.content}}</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row v-else :gutter="20">
          <el-col :span="24">
            <img style="width: 100%;border-radius: 1rem;" :src="fundProjectInfo.imgUrl" alt="">
          </el-col>
          <el-col :span="24">
            <div style="display: flex;align-items: center;justify-content: center;width:100%;">
              <div>
                <h2>{{fundProjectInfo.name}}</h2>
                <div style="font-size: 1.2rem;margin-top: 2rem;line-height: 2;">{{fundProjectInfo.content}}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div>
        <div class="sector-info-middle">
          <h2 style="margin-left: 0.2rem">{{ $t('CorrelationNews') }}</h2>
        </div>
        <div class="middle-text-bottom" :class="$i18n.locale == 'zh'?'middle-text-bottom-zh':'middle-text-bottom-en'">
        </div>
        <div class="middle-bottom">

        </div>
      </div>
      <div class="sector-info-bottom">
        <el-row :gutter="20" class="mission">
          <el-col :span="screenWidth>640?12:24" v-for="item in fundProjectInfo.moduleTypeList" :key="item.name">
            <div class="sector-list">
              <div class="sector-list-title">
                <img src="@/assets/img/small-title.png" alt="" width="15rem">
                <span style="margin-left: 0.5rem;" class="text-max-1">{{item.name}}</span>
              </div>
              <div class="sector-list-content">
                <div class="sector-list-item" :style="{'padding-bottom': index== (item.articles.length -1)? '1rem':'0'}" v-for="(newsiItem,index) in item.articles" :key="newsiItem.id">
                  <div class="sector-list-item-title" @click="toJump(newsiItem.id,item.id,newsiItem.activeUrl)">
                    <div class="sector-list-item-title-name">{{newsiItem.createDate}}</div>
                    <div class="text-max-1">{{newsiItem.title}}</div>
                    <el-divider v-if="index != (item.articles.length-1)" style="margin: 0;"></el-divider>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>



    <!-- 移动端 -->
    <div class="sector-info-mobile" v-if="isMobile == 'mobile'">
      <div class="navigation-title" style="margin-left: 1rem;margin-top: 0;padding-top: 1rem"><span @click="()=>{$router.push('/foundationProject')}">{{ $t('FoundationProject') }}</span> <i class="el-icon-arrow-right"></i> {{ fundProjectInfo.name }}</div>
      <div style="" class="sector-info-top">
        <el-row v-if="screenWidth>640" :gutter="20" style="display: flex;align-items: center;justify-content: center;">
          <el-col :span="10">
            <img style="width: 100%;border-radius: 1rem;" :src="fundProjectInfo.imgUrl" alt="">
          </el-col>
          <el-col :span="14">
            <div style="display: flex;align-items: center;justify-content: center;width:100%;">
              <div>
                <h2>{{fundProjectInfo.name}}</h2>
                <div style="font-size: 1.2rem;margin-top: 2rem;">{{fundProjectInfo.content}}</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row v-else :gutter="20">
          <el-col :span="24">
            <img style="width: 100%;border-radius: 1rem;" :src="fundProjectInfo.imgUrl" alt="">
          </el-col>
          <el-col :span="24">
            <div style="display: flex;align-items: center;justify-content: center;width:100%;">
              <div>
                <h2>{{fundProjectInfo.name}}</h2>
                <div style="font-size: 1.2rem;margin-top: 2rem;">{{fundProjectInfo.content}}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div>
        <div class="sector-info-middle">
          <h2 style="margin-left: 0.2rem">{{ $t('CorrelationNews') }}</h2>
        </div>
        <div class="middle-text-bottom" :class="$i18n.locale == 'zh'?'middle-text-bottom-zh':'middle-text-bottom-en'">
        </div>
        <div class="middle-bottom">

        </div>
      </div>
      <div class="sector-info-bottom">
        <el-row :gutter="20" class="mission">
          <el-col :span="screenWidth>640?12:24" v-for="item in fundProjectInfo.moduleTypeList" :key="item.name">
            <div class="sector-list">
              <div class="sector-list-title">
                <img src="@/assets/img/small-title.png" alt="" width="15rem">
                <span style="margin-left: 0.5rem;" class="text-max-1">{{item.name}}</span>
              </div>
              <div class="sector-list-content">
                <div class="sector-list-item" :style="{'padding-bottom': index== (item.articles.length -1)? '1rem':'0'}" v-for="(newsiItem,index) in item.articles" :key="newsiItem.id">
                  <div class="sector-list-item-title" @click="toJump(newsiItem.id,item.id,newsiItem.activeUrl)">
                    <div class="sector-list-item-title-name">{{newsiItem.createDate}}</div>
                    <div class="text-max-1">{{newsiItem.title}}</div>
                    <el-divider v-if="index != (item.articles.length-1)" style="margin: 0;"></el-divider>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
  
</template>

<script>
import { listInfo, getFundProjectInfo } from '@/api/index';
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
      fundProjectInfo: {},
      aboutFoundation: {},
      missions: [],
    };
  },
  mounted() {
	 this.id = this.$route.query.id
	 this.fundId = this.$route.query.fundId
    this.search(this.id);
  },
  methods: {
    search(id) {
      const formData = new FormData();
      formData.append("id", id);
      getFundProjectInfo(formData).then(res => {
        this.fundProjectInfo = res.data;
      })
    },
    toJump(id,fundId,activeUrl) {
		if(activeUrl != null && activeUrl != '' && activeUrl != undefined){
			this.$router.push({
			  path: activeUrl,
			  query: {
			  },
			});
		}else{
			this.$router.push({
			  path: '/foundationProjectDetails',
			  query: {
			    id: id,
				fundId:fundId
			  },
			});
		}
    },
  }
};
</script>

<style lang="less" scoped>
.pc-bg{
  background: #fff;
}
.sector-info {
  width: 90%;
  margin: 1rem auto;
  .sector-info-top {
    margin: 1rem 0;
    padding: 0 1.5rem 0 0;
    background: #f8f8f8;
    border-radius: 1rem;
  }
  .sector-info-middle {
    height: 3rem;
    line-height: 3rem;
    margin-top: 2rem;
  }
  .middle-text-bottom {
    height: 0.4rem;
    background: #aa221d;
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
    position: relative;
    top: 0.4rem;
  }
  .middle-text-bottom-zh {
    width: 6.4rem;
  }
  .middle-text-bottom-en {
    width: 12.8rem;
  }
  .middle-bottom {
    height: 0.4rem;
    background: #e5e5e5;
    border-radius: 0.2rem;
  }
  .sector-info-bottom {
    .sector-list {
      border-radius: 1rem;
      background: white;
      margin: 2rem 0;
      .sector-list-title {
        width: 100%;
        color: #aa221d;
        font-size: 1.2rem;
        font-weight: 800;
        line-height: 1.5rem;
        height: 3.5rem;
        background: #ededed;
        padding: 1rem 2rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        overflow: height;
      }
      .sector-list-content {
        overflow-y: scroll;
        height: 25rem;
        padding: 1.5rem 0;
        background: #f8f8f8;
        .sector-list-item {
          padding: 0 2rem;
          .sector-list-item-title {
            font-size: 1rem;
            line-height: 1.8rem;
            cursor: pointer;
            .sector-list-item-title-name {
              color: #797c95;
            }
          }
        }
      }
    }
  }
}



.sector-info-mobile {
  padding: 0 18px;
  margin: 1rem auto;
  background: #fff;
  .sector-info-top {
    margin: 1rem 0;
    padding: 2rem 1.5rem;
    background: #f8f8f8;
    border-radius: 1rem;
  }
  .sector-info-middle {
    height: 3rem;
    line-height: 3rem;
    margin-top: 2rem;
  }
  .middle-text-bottom {
    height: 0.4rem;
    background: #aa221d;
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
    position: relative;
    top: 0.4rem;
  }
  .middle-text-bottom-zh {
    width: 6.4rem;
  }
  .middle-text-bottom-en {
    width: 12.8rem;
  }
  .middle-bottom {
    height: 0.4rem;
    background: #e5e5e5;
    border-radius: 0.2rem;
  }
  .sector-info-bottom {
    .sector-list {
      border-radius: 1rem;
      background: white;
      margin: 2rem 0;
      .sector-list-title {
        width: 100%;
        color: #aa221d;
        font-size: 1.2rem;
        font-weight: 800;
        line-height: 1.5rem;
        height: 3.5rem;
        background: #ededed;
        padding: 1rem 2rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        overflow: height;
      }
      .sector-list-content {
        overflow-y: scroll;
        // height: 25rem;
        padding: 1.5rem 0;
        background: #f8f8f8;
        .sector-list-item {
          padding: 0 2rem;
          .sector-list-item-title {
            font-size: 1rem;
            line-height: 1.8rem;
            cursor: pointer;
            .sector-list-item-title-name {
              color: #797c95;
            }
          }
        }
      }
    }
  }
}

.sector-list-item:hover {
  color: #aa221d !important;
  .sector-list-item-title-name {
    color: #aa221d !important;
  }
}
.el-divider--horizontal {
  margin: 0.9rem 0 !important;
}
div::-webkit-scrollbar {
  display: none;
}
</style>